import createCache from "@emotion/cache";

export const emotionCache = createCache({
  key: "css",
  // In production, use speedy mode (CSSOM insertRule) for better performance
  // In development, style tags are used for better debugging
  speedy: import.meta.env.PROD,
});
